<div *ngIf="!dashboard && ((!fhirEmbedded) || (fhirFullSite))">
  <app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'MESSAGES'" [breadcrumb]="breadcrumb" [count]="count"
    icon="fa-envelope">
  </app-breadcrumb>
</div>
<kendo-splitter #splitter orientation="vertical" (layoutChange)="updateSplitterBar()">
  <kendo-splitter-pane [collapsible]="true">
    <div [ngClass]="{'content-background': !fhirEmbedded || fhirFullSite, 'mb-3': fhirEmbedded}">
      <div class="row mr-0">
        <div class="col-sm-6">
          <!--Action buttons for INBOX-->
          <ng-container *ngIf="breadcrumb === 'INBOX'">
            <button kendoButton [primary]="true" class="mr-3" (click)="newMessage()" type="button">{{ 'COMPOSE' |
              translate }}<i class="far fa-envelope-open"></i>
            </button>
            <button kendoButton [primary]="true" class="mr-3" (click)="deleteMessages()" type="button"
              [disabled]="selectedMessages.length === 0">{{ 'DELETE' | translate }}<i class="far fa-trash-alt"></i>
            </button>
            <button kendoButton [primary]="true" class="mr-3" (click)="unreadMessages()" type="button"
              [disabled]="selectedMessages.length === 0">{{ 'MARK-AS-UNREAD' | translate }}<i
                class="far fa-envelope"></i>
            </button>
            <button kendoButton [primary]="true" class="mr-3" (click)="readMessages()" type="button"
              [disabled]="selectedMessages.length === 0">{{ 'MARK-AS-READ' | translate }}<i
                class="far fa-envelope"></i>
            </button>
          </ng-container>
          <!--Action buttons for SENT-->
          <ng-container *ngIf="breadcrumb === 'SENT'">
            <!--Just use this empty div to get the same height as the two others-->
            <div style="min-height: 42px;">
            </div>
          </ng-container>
          <!--Action buttons for DELETED-->
          <ng-container *ngIf="breadcrumb === 'DELETED'">
            <button kendoButton [primary]="true" class="mr-3" (click)="undeleteMessages()" type="button"
              [disabled]="selectedMessages.length === 0">{{ 'UNDELETE' | translate }}<i
                class="far fa-envelope-open-text"></i>
            </button>
            <button kendoButton [primary]="true" class="mr-3" (click)="confirmEraseDialogOpened = true" type="button"
              *ngIf="allowHardDelete" [disabled]="selectedMessages.length === 0">
              {{ 'DELETE' | translate }}<i class="far fa-trash-alt"></i>
            </button>
          </ng-container>
        </div>
        <div class="col-sm-6">
          <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="messageGridAdvancedSwitch" [storageKey]="'messages-list'"
              (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
            <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-SUBJECT' | translate }}"
              [formControl]="searchControl" title="{{ 'SEARCH-SUBJECT' | translate }}" />
            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <kendo-grid #grid [data]="gridView" [loading]="loading" [navigable]="true"
          [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes } : false" [pageSize]="state.take"
          [skip]="state.skip" [sortable]="true" [sort]="state.sort" [filterable]="enableAdvanced"
          [filter]="state.filter" [selectable]="{ mode: 'multiple' }" [columnMenu]="enableAdvanced" [resizable]="true"
          [reorderable]="enableAdvanced" [selectedKeys]="selectedMessages" (dataStateChange)="dataStateChange($event)"
          [kendoGridSelectBy]="" (selectedKeysChange)="onSelectedKeysChange($event)" (pageChange)="pageChange()">
          <kendo-grid-messages noRecords="{{ 'NO-MESSAGES' | translate }}">
          </kendo-grid-messages>
          <kendo-grid-checkbox-column *ngIf="breadcrumb !== 'SENT'" [columnMenu]="false" [showSelectAll]="true"
            [width]="18" class="text-center" headerClass="text-center">
          </kendo-grid-checkbox-column>
          <kendo-grid-column headerClass="text-center" field="attachment" [width]="18" [sortable]="false"
            [filterable]="false" [columnMenu]="false">
            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
              <i class="fas fa-paperclip w-100" title="{{ 'MESSAGE-WITH-ATTACHMENTS' | translate }}" role="img"
                attr.aria-label="{{ 'MESSAGE-WITH-ATTACHMENTS' | translate }}"></i>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="text-center">
                <i *ngIf="dataItem.attachments" class="fas fa-paperclip"
                  title="{{ 'MESSAGE-WITH-ATTACHMENTS' | translate }}" role="img"
                  attr.aria-label="{{ 'MESSAGE-WITH-ATTACHMENTS' | translate }}">
                </i>
              </div>
            </ng-template>
          </kendo-grid-column>
          <!--For Sent we show toAddresses column instead of fromdeleteMessages-->
          <kendo-grid-column *ngIf="breadcrumb === 'SENT'" field="toAddresses" title="{{ 'TO' | translate }}"
            [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="ellipsis-text" title="{{dataItem.toAddresses}}">{{dataItem.toAddresses}}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column *ngIf="breadcrumb !== 'SENT'" field="from" title="{{ 'FROM' | translate }}" [width]="50"
            class="ellipsis-text">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="ellipsis-text" title="{{dataItem.from}}">{{dataItem.from}}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column *ngIf="breadcrumb !== 'SENT'" field="fromOrganization"
            title="{{ 'FROM-ORGANIZATION' | translate }}" [width]="90">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="ellipsis-text" title="{{ dataItem.fromOrganization }}">{{ dataItem.fromOrganization }}</div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="subject" title="{{ 'SUBJECT' | translate }}" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="ellipsis-text" [class]="dataItem.status === 'Unread'? 'unread':''"
                title="{{ dataItem.subject }}">
                {{ dataItem.subject }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="body" title="{{ 'MESSAGE' | translate }}" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="ellipsis-text" title="{{dataItem.body}}" [class]="dataItem.status === 'Unread'? 'unread':''">
                {{ dataItem.body }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="memberName" title="{{ 'MEMBER' | translate:patientLabel }}" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
              <a *ngIf="dataItem.memberId && isMemberAndCaseLinkEnabled" [routerLink]="['/patient', dataItem.memberId]"
                class="pointer emphasizedLabel font-weight-bold ellipsis-text" title="{{ dataItem.memberName }}">
                {{ dataItem.memberName }}
              </a>
              <div class="ellipsis-text" *ngIf="dataItem.memberId && !isMemberAndCaseLinkEnabled">{{ dataItem.memberName
                }}
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="caseName" title="{{ 'CHANNEL' | translate }}" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="dataItem.caseId">
                <div
                  [ngSwitch]="(dataItem.caseAccessible === null || dataItem.caseAccessible) && isMemberAndCaseLinkEnabled">
                  <div *ngSwitchCase="true" class="ellipsis-text">
                    <a [routerLink]="['/case', dataItem.caseId]" class="pointer emphasizedLabel font-weight-bold"
                      title="{{dataItem.channelName}}">
                      {{ dataItem.channelName }}
                    </a>
                  </div>
                  <div *ngSwitchDefault class="ellipsis-text">{{ dataItem.channelName }}</div>
                </div>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="sentOn"
            title="{{ (this.breadcrumb === 'SENT' ? 'SENT-ON' : 'RECEIVED') | translate }}" [width]="60" filter="date"
            format="{0:d}">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                <kendo-filter-eq-operator></kendo-filter-eq-operator>
                <kendo-filter-neq-operator></kendo-filter-neq-operator>
                <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                <kendo-filter-after-operator></kendo-filter-after-operator>
                <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                <kendo-filter-before-operator></kendo-filter-before-operator>
              </kendo-grid-date-filter-cell>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              <div *ngIf="dataItem.sentOn !== null">{{ intl.formatDate(intl.parseDate(dataItem.sentOn), 'g') }}</div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </kendo-splitter-pane>
  <kendo-splitter-pane *ngIf="selected">
    <div [ngClass]="{'content-background': !fhirEmbedded || fhirFullSite, 'mt-3': fhirEmbedded}">
      <app-message-detail [message]="selected" [messageList]="view" [type]="breadcrumb"></app-message-detail>
    </div>
  </kendo-splitter-pane>
</kendo-splitter>

<!--New message dialog-->
<kendo-dialog *ngIf="messageDialogOpened" (close)="messageDialogOpened=false" [minWidth]="400" [width]="700">
  <kendo-dialog-titlebar>
    <h3>{{ 'NEW-MESSAGE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <app-message-compose #messageCompose [messageDialogOpened]="messageDialogOpened" [memberId]="getNewMessageMemberId()"
    [caseId]="" [messageList]="" [fromMessagesScreen]="'message'" (afterSave)="closeNewMessage();"
    (saving)="savingMessage=$event;messageDialogOpened=false">
  </app-message-compose>
  <kendo-dialog-actions>
    <button kendoButton (click)="messageDialogOpened = false" [disabled]="savingMessage">{{ 'CANCEL' | translate
      }}</button>
    <button appPreventClick #submitButton kendoButton type="button"
      [disabled]="!messageCompose.formValid() || savingMessage" (click)="messageCompose.save($event);">
      {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Confirm erase dialog -->
<kendo-dialog *ngIf="confirmEraseDialogOpened" (close)="confirmEraseDialogOpened = false" [minWidth]="400">
  <kendo-dialog-titlebar>
    <h3>{{'DELETE-MESSAGE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <label>{{'CONFIRM-DELETE-MESSAGE' | translate}}</label>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="confirmEraseDialogOpened = false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="eraseMessages(); confirmEraseDialogOpened = false">
      {{'YES' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>